module.exports = __webpack_public_path__ + "static/FinalsScoreFSlogo-2501833a9450dc3f9d2fdd41351c3c3c.png";